<div class="row">
  <div class="col-lg-3 col-xs-12">
    <div class="col-left py-5 px-4">
      <h2 class="mb-4">{{ 'popins.search_consumer.title' | translate }}</h2>
      <div class="mt-2">
        <p class="custom-form-row">
          <label for="input-search-consumer-email">{{ 'popins.signup.label3' | translate }}</label>
          <input
            type="email"
            [(ngModel)]="inputs.email"
            name="input-search-consumer-email"
            id="input-search-consumer-email"
            autocomplete="email"
            autocorrect="off"
            spellcheck="false" />
        </p>
      </div>

      <div class="my-2">{{ 'popins.search_consumer.label2' | translate }}</div>

      <div>
        <p class="custom-form-row">
          <label for="input-search-consumer-last-name">{{ 'popins.signup.label1' | translate }}</label>
          <input
            type="text"
            [(ngModel)]="inputs.lastname"
            name="input-search-consumer-last-name"
            id="input-search-consumer-last-name"
            autocomplete="family-name"
            autocorrect="off"
            spellcheck="false" />
        </p>
      </div>
      <div class="my-2">{{ 'popins.search_consumer.label2' | translate }}</div>
      <div>
        <p class="custom-form-row">
          <label for="input-search-consumer-consumer-zipcode">{{ 'popins.signup.label9' | translate }}</label>
          <input
            type="text"
            [(ngModel)]="inputs.zipcode"
            name="input-search-consumer-zipcode"
            id="input-search-consumer-zipcode"
            autocomplete="postal-code"
            autocorrect="off"
            spellcheck="false" />
        </p>
      </div>

      <div class="my-2">{{ 'popins.search_consumer.label2' | translate }}</div>

      <div class="mb-2">
        <p class="custom-form-row">
          <label for="input-search-consumer-id">{{ 'popins.search_consumer.label1' | translate }}</label>
          <input
            type="text"
            [(ngModel)]="inputs.customerId"
            name="input-search-consumer-id"
            id="input-search-consumer-id"
            autocomplete="castorama-id"
            autocorrect="off"
            spellcheck="false" />
        </p>
      </div>
      <div class="my-2">{{ 'popins.search_consumer.label2' | translate }}</div>
      <div class="mb-2">
        <p class="custom-form-row">
          <label for="input-search-phone">{{ 'popins.search_consumer.phone' | translate }}</label>
          <input
            type="text"
            [(ngModel)]="inputs.phone"
            name="input-search-phone"
            id="input-search-phone"
            autocomplete="castorama-id"
            autocorrect="off"
            spellcheck="false" />
        </p>
      </div>
      <div class="my-2">{{ 'popins.search_consumer.label2' | translate }}</div>
      <div class="mb-2">
        <p class="custom-form-row">
          <label for="input-search-fidelity">{{ 'popins.search_consumer.fidelity' | translate }}</label>
          <input
            type="text"
            [(ngModel)]="inputs.fidelityId"
            name="input-search-fidelity"
            id="input-search-fidelity"
            autocomplete="castorama-id"
            autocorrect="off"
            spellcheck="false" />
        </p>
      </div>

      <div class="pt-2">
        <ng-casto-btn
          class="light-grey"
          [loading]="isLoading"
          (click)="search()"
          [label]="'popins.search_consumer.btn' | translate"></ng-casto-btn>
      </div>
    </div>
  </div>

  <div class="col-lg-9 col-xs-12">
    <div class="header-actions">
      <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>

    <div class="modal-content-body">
      <div class="result-container pt-5 pr-3" *ngIf="searchResults">
        <div class="error-text pt-5" *ngIf="searchResults.length === 0" [innerHtml]="requestError"></div>

        <table *ngIf="searchResults.length > 0" class="table result-table">
          <thead>
            <tr>
              <th>
                <span>{{ 'popins.signup.label2' | translate }}&nbsp;{{ 'popins.signup.label1' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.search_consumer.label1' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.signup.label9' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.signup.label3' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.search_consumer.phone' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.search_consumer.fidelity' | translate }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let consumer of searchResults" (click)="selectCustomer(consumer)">
              <td>{{ consumer.firstname }} {{ consumer.lastname }}</td>
              <td>{{ consumer.id }}</td>
              <td>{{ consumer.address?.postalCode }}</td>
              <td>{{ consumer.email }}</td>
              <td>{{ consumer.phoneNumber }}</td>
              <td>{{ consumer.fidelity?.number }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="footer">
      <div class="text-right">
        <ng-casto-btn
          class="blue"
          (click)="addNewCustomer()"
          [label]="'popins.search_consumer.add_consumer' | translate"></ng-casto-btn>
      </div>
    </div>
  </div>
</div>
